import React from 'react'
import { Box, Button, Typography } from '@mui/material'

import GoogleIcon from '../../../../components/icon/GoogleIcon'
import {
  UI_COLOR_DANGER_DEEP,
  UI_COLOR_SURFACE_SCAN_DARK,
  UI_COLOR_WHITE
} from '../../../../constants/uiColors'

const RefundScanCameraView = ({
  videoRef,
  canvasRef,
  cameraError,
  cameraStatus,
  cameraCodeError,
  canSwitchCamera = false,
  onRefocus,
  onSwitchCamera,
  onBack
}) => (
  <Box
    sx={{
      height: '100%',
      backgroundColor: UI_COLOR_SURFACE_SCAN_DARK,
      color: UI_COLOR_WHITE,
      borderRadius: 1,
      overflow: 'hidden',
      position: 'relative'
    }}
  >
    <Box
      sx={{
        height: 44,
        display: 'grid',
        gridTemplateColumns: '44px 1fr 44px',
        alignItems: 'center',
        px: 0.5
      }}
    >
      <Button
        variant="text"
        onClick={onBack}
        sx={{ minWidth: 0, color: UI_COLOR_WHITE, p: 1 }}
        aria-label="Volver"
      >
        <GoogleIcon name="arrow_back" size={20} color={UI_COLOR_WHITE} />
      </Button>
      <Typography sx={{ textAlign: 'center', fontSize: 14, fontWeight: 700 }}>Cámara</Typography>
      {canSwitchCamera ? (
        <Button
          variant="text"
          onClick={onSwitchCamera}
          sx={{ minWidth: 0, color: UI_COLOR_WHITE, p: 1 }}
          aria-label="Cambiar cámara"
        >
          <GoogleIcon name="cameraswitch" size={20} color={UI_COLOR_WHITE} />
        </Button>
      ) : (
        <Box aria-hidden="true" />
      )}
    </Box>

    <Box
      sx={{
        width: '100%',
        height: 'calc(100% - 44px)',
        position: 'relative',
        overflow: 'hidden',
        display: cameraError ? 'none' : 'block'
      }}
    >
      <Box
        component="video"
        ref={videoRef}
        autoPlay
        playsInline
        muted
        aria-label="Reenfocar cámara"
        onClick={onRefocus}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
          cursor: onRefocus ? 'pointer' : 'default',
          touchAction: 'manipulation'
        }}
      />
      <Box
        aria-hidden="true"
        sx={{
          position: 'absolute',
          left: '8%',
          top: '36%',
          width: '84%',
          height: '34%',
          border: `3px solid ${cameraCodeError ? UI_COLOR_DANGER_DEEP : UI_COLOR_WHITE}`,
          borderRadius: 1,
          boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.38)',
          pointerEvents: 'none',
          transition: 'border-color 150ms ease'
        }}
      />
    </Box>
    <Box component="canvas" ref={canvasRef} sx={{ display: 'none' }} />

    {(cameraError || cameraStatus) && (
      <Box
        sx={{
          position: 'absolute',
          left: 20,
          right: 20,
          top: cameraError ? '50%' : 'auto',
          bottom: cameraError ? 'auto' : 64,
          transform: cameraError ? 'translateY(-50%)' : 'none',
          textAlign: 'center',
          color: UI_COLOR_WHITE,
          backgroundColor: cameraCodeError ? 'rgba(220, 38, 38, 0.88)' : 'rgba(0, 0, 0, 0.45)',
          borderRadius: 1,
          py: cameraError ? 0 : 0.75,
          px: cameraError ? 0 : 1
        }}
      >
        {cameraError && <Typography sx={{ fontSize: 13 }}>{cameraError}</Typography>}
        <Typography sx={{ fontSize: 10, mt: 0.5, opacity: 0.9 }}>
          {cameraError
            ? 'Haz clic en el icono de candado en la barra de direcciones y restablece el permiso de cámara.'
            : cameraStatus}
        </Typography>
      </Box>
    )}
  </Box>
)

export default RefundScanCameraView
